module.exports = __webpack_public_path__ + "img/R-2.4d8a5f37.png";